import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { i18n } from "@/lib/i18n";
import { appShellTitle } from "@/lib/seo/head";

function ProjectShell() {
  const { t } = useTranslation();
  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">{t("shells.project")}</h1>
    </section>
  );
}

export const Route = createFileRoute("/projects/$projectId")({
  head: () => ({ meta: [{ title: appShellTitle(i18n.t("shells.project")) }] }),
  component: ProjectShell,
});
